<template>
  <div>
    <a-modal
      title="Edit room type"
      :visible="bookMatchTypeNum !== null"
      :maskClosable="false"
      @cancel="handleRoomTypeCancel"
    >
      <a-form :form="roomTypeForm" autocomplete="off" class="roomType">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Room Number"
        >
          <span>#2</span>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Adt Count"
        >
          <span style="margin-right:10px">2</span><span style="color:rgba(0,0,0,.85)">Cwb Count: </span><span style="margin-right:10px">2</span><span style="color:rgba(0,0,0,.85)">Cnb Count: </span><span>0</span>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Room Type"
        >
          <a-select>
            <a-select-option value="SG">SG</a-select-option>
            <a-select-option value="DBL">DBL</a-select-option>
            <a-select-option value="TW">TW</a-select-option>
            <a-select-option value="TRI">TRI</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-show="false">
          <a-input
            v-decorator="[
              'roomNumber',
              {
              rules: [{ required: true, message: '' }],
              }
            ]"
          />
        </a-form-item>
        <a-form-item v-show="false">
          <a-input
            v-decorator="[
              'tourId',
              {
              rules: [{ required: true, message: '' }],
              }
            ]"
          />
        </a-form-item>
        <a-form-item v-show="false">
          <a-input
            v-decorator="[
              'bkrId',
              {
              rules: [{ required: true, message: '' }],
              }
            ]"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-popconfirm
          title="Are you sure?"
          @confirm="handleRoomTypeConfirm"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary">Confirm</a-button>
        </a-popconfirm>
      </template>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'BookMatchRoomType',
  components: {
  },
  props: {
    bookMatchTypeNum: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      roomTypeForm: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    handleRoomTypeCancel () {
      this.$emit('cancel')
    },
    handleRoomTypeConfirm () {
       this.$emit('confirm')
    }
  }
}
</script>
<style lang="less" scoped>
.roomType ::v-deep .ant-form-item {
    margin-bottom: 0;
}
</style>